import { useUsers } from '../../metodos/userContext';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../DashboardLayout';
import logo from '../../assets/logo.png';
import { 
  Calculator, LogOut, Menu as MenuIcon, X,
} from 'lucide-react';
import { useAuth } from '../../metodos/AuthContext';

const filteredRoutes = [ 
  { 
    name: "Dashboard", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
  },
  /*
  { 
    name: "Calendario", 
    icon: <Calculator size={20} />, 
    path: "/calendario",
  },
  { 
    name: "Pro Plataforma", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
  },
  { 
    name: "Tesis", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
  },
  { 
    name: "Configuracion", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
  },
  { 
    name: "Servicios realizados", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
  },
  */
];

const HomeScreenCliente = () => {
  const { usuario} = useUsers();
  const navigate = useNavigate();
  const {logout} = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <DashboardLayout 
      routes={filteredRoutes} // Pasamos las rutas ya filtradas
      user={usuario}          // Pasamos el usuario para el Topbar
      onLogout={handleLogout} // Pasamos la función de salir
      appTitle="Portal Cliente"
      customLogo={logo}
    />
  );

}

export default HomeScreenCliente
